// layouts/catalogos/grabacion/nueva-grabacion.js

import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

import FormPage from "ui/FormPage";
import { PrimaryButton, OutlineButton } from "ui/Buttons";
import FormTextField from "ui/FormTextField";

import { createRecordType } from "../services/grabacion";

/* ---------------- helpers ---------------- */
function parseApiErrors(err) {
  const out = [];
  const res = err?.response;
  const d = res?.data ?? err;

  const push = (m) => {
    if (m == null) return;

    if (typeof m === "string") { out.push(m); return; }
    if (typeof m === "number" || typeof m === "boolean") { out.push(String(m)); return; }

    if (Array.isArray(m)) { m.forEach(push); return; }

    if (typeof m === "object") {
      if (Array.isArray(m.errors))  m.errors.forEach(push);
      if (Array.isArray(m.message)) m.message.forEach(push);
      if (Array.isArray(m.details)) m.details.forEach(push);
      if (Array.isArray(m.issues))  m.issues.forEach(push);

      if (typeof m.message === "string") out.push(m.message);
      if (typeof m.msg === "string")      out.push(m.msg);
      if (typeof m.error === "string")    out.push(m.error);

      if (m.instancePath || m.path || m.dataPath) {
        const path = String(m.instancePath || m.path || m.dataPath || "")
          .replace(/^\//, "").replace(/\//g, ".");
        const msg = m.message || m.msg || "error";
        out.push(path ? `${path}: ${msg}` : msg);
      }

      if (out.length === 0) {
        try { out.push(JSON.stringify(m)); } catch { out.push(String(m)); }
      }
      return;
    }

    out.push(String(m));
  };

  push(d);
  if (res?.statusText && res.statusText !== "OK") out.push(res.statusText);
  if (res?.status) out.push(`HTTP ${res.status}`);

  if (out.length === 0) out.push("Error del servidor");
  return [...new Set(out)].filter(Boolean);
}
/* ----------------------------------------- */

export default function NuevaGrabacion() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const isValid = useMemo(() => !!name.trim(), [name]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) {
      setErrors(["El nombre es obligatorio."]);
      return;
    }

    setSaving(true);
    setErrors([]);

    try {
      await createRecordType({ name: name.trim() }); // 👈 SOLO NAME
      navigate("/catalogos/grabacion", { replace: true });
    } catch (e2) {
      const errs = parseApiErrors(e2);
      setErrors(Array.isArray(errs) ? errs : [String(errs || "Error")]);
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormPage
      title="Nueva grabación"
      onBack={() => navigate("/catalogos/grabacion")}
      pageMaxWidth={1100}
      contentMaxWidth={900}
      actions={
        <>
          <PrimaryButton
            type="submit"
            form="form-grab"
            disabled={!isValid || saving}
          >
            {saving ? "Guardando..." : "Guardar"}
          </PrimaryButton>
          <OutlineButton onClick={() => navigate("/catalogos/grabacion")}>
            Cancelar
          </OutlineButton>
        </>
      }
    >
      {errors.length > 0 && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errors.length === 1 ? errors[0] : (
            <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
              {errors.map((m, i) => <li key={i}>{m}</li>)}
            </ul>
          )}
        </Alert>
      )}

      <form id="form-grab" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormTextField
              label="Nombre*"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </Grid>
        </Grid>
      </form>
    </FormPage>
  );
}
